/* src/app/modules_v2/investment/investment-asset-shared/components/investment-asset-form-dialog/investment-asset-form-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.iaf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.iaf-body {
  padding: 0 !important;
}
.iaf-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 1fr);
}
.iaf-main {
  min-width: 0;
  border-right: 1px solid #f0f0f0;
}
.iaf-side {
  min-width: 0;
}
.iaf-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.iaf-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.iaf-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.iaf-label-hint {
  font-size: 12px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
}
.iaf-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 16px;
}
.iaf-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.iaf-provider {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.iaf-provider__field {
  flex: 1;
  min-width: 0;
}
.iaf-provider__btn {
  margin-top: 8px;
  flex-shrink: 0;
}
.iaf-hint {
  font-size: 12px;
  color: #6b7280;
  margin: -12px 0 12px 4px;
}
.iaf-hint--warning {
  margin: -4px 0 12px;
  padding: 8px 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  color: #92400e;
}
.iaf-totals {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}
.iaf-total {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: #f4f6f8;
  border-radius: 8px;
}
.iaf-total--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.iaf-total__label {
  font-size: 12px;
  color: #6b7280;
}
.iaf-total__value {
  font-size: 16px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.iaf-file-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.iaf-file-input {
  display: none;
}
.iaf-btn--danger {
  color: #dc2626 !important;
}
.iaf-file-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 220px;
  padding: 16px;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}
.iaf-file-empty mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #cbd5e1;
}
.iaf-file-preview {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
  margin-bottom: 12px;
}
.iaf-file-preview img {
  display: block;
  max-width: 100%;
  max-height: 480px;
  margin: 0 auto;
  object-fit: contain;
}
.iaf-file-preview iframe {
  display: block;
  width: 100%;
  height: 480px;
  border: 0;
}
.iaf-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.iaf-alert mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.iaf-alert--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}
.iaf-save-error {
  margin: 0 24px 16px;
}
@media (max-width: 900px) {
  .iaf-layout {
    grid-template-columns: 1fr;
  }
  .iaf-main {
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
  }
}
@media (max-width: 600px) {
  .iaf-section {
    padding: 14px 16px 6px;
  }
  .iaf-grid,
  .iaf-grid--2,
  .iaf-totals {
    grid-template-columns: 1fr;
  }
  .iaf-provider {
    flex-direction: column;
    align-items: stretch;
  }
  .iaf-provider__btn {
    margin-top: -8px;
    margin-bottom: 12px;
  }
}
/*# sourceMappingURL=investment-asset-form-dialog.component.css.map */
